import type { Invitation } from '@sine/sine-core-api-types';

import type { PassWithResponseSummaries } from '../../../activity/helpers/activityFeedCache.helpers';

export function generatePrefillPassFromInvitation(invitation: Invitation) {
  return {
    invitation: invitation.id,
    firstName: invitation.firstName,
    lastName: invitation.lastName,
    email: invitation.email || '',
    mobile: invitation.mobile || '',
    company: invitation.companyDetails?.name,
    companyId: (invitation.companyDetails as any)?.id,
    companySource: (invitation.companyDetails as any)?.companySource,
    adminNotes: invitation.adminNotes,
    visitorNotes: invitation.visitorNotes,
    site: invitation.site || (invitation as any).siteId,
    host: invitation.host || (invitation as any).hostId,
    visitorType: invitation.visitorType,
    photoURL: invitation.photoURL,
    zone: invitation.zoneId,
  };
}

export function generatePrefillPassFromPass(pass: PassWithResponseSummaries | undefined) {
  return {
    firstName: pass?.firstName,
    lastName: pass?.lastName,
    email: pass?.email || '',
    mobile: pass?.mobile || '',
    company: pass?.companyDetails?.name,
    companyId: pass?.companyDetails?.id,
    companySource: pass?.companyDetails?.companySource,
    adminNotes: undefined,
    visitorNotes: undefined,
    site: pass?.site,
    host: pass?.host,
    visitorType: pass?.visitorType,
    photoURL: pass?.photoURL,
    zone: pass?.zoneId,
  };
}

export type PrefillPass =
  | ReturnType<typeof generatePrefillPassFromPass>
  | ReturnType<typeof generatePrefillPassFromInvitation>;
